var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay{width:100%;height:100%;background:rgba(0,0,0,.4);padding-top:90px;display:block;padding-bottom:90px}#home{background:url(" + escape(require("../../assets/images/home-bg.jpg")) + ") no-repeat;background-size:cover;color:#fff;text-align:center;width:100%;border:none;box-shadow:0 2px 8px 0 rgba(50,50,50,.08);margin:0!important}#home p{font-weight:400;font-style:italic;line-height:2em}.tm-white{margin:0 0 10px}h1{color:orange}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7808df0e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/home.vue
// module id = 39
// module chunks = 0